import ContaReceberModel from "./contaReceberModel";

export default class ContaReceberMultiplasModel extends ContaReceberModel {
    juros = 0;
    desconto = 0;
    valorRecebido = 0;
    formaPagamentoId = 0;
}
